<template>
  <div class="home">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
        
        <va-card v-for="(route, index) in exerciseRoutes " :key="index"  gradient 
        color="color5" :href="route.path"
        class="col cursor-pointer hover:opacity-80 md:h-36"
        >
        <va-card-content>
            <va-card-title class="text-2xl">{{ route.meta.routeTitle }}</va-card-title>
          </va-card-content>

        </va-card>
      </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';

const names = [
  'simple-scale',
  'continuous-intervals',
  'discrete-intervals',
  'arpeggio',
  'rhythm'
]
const exerciseRoutes = useRouter().getRoutes().filter(r => names.includes(String(r.name )))
</script>
